/*
 * 任务清单相关全局交互
 */

(function($) {

  $(function() {
    var wrapper = $(".wrapper");

    // create todolist
    wrapper.on('click', '.btn-new-todolist', showTodolistForm)
      .on('click', '.btn-cancel-todolist', hideTodolistForm)
      .on('ajax:success', '.todolist-form.new .form', createTodolistSuccess)
      .on('keydown', '.todolist-form', createTodolistShortcuts)
      .on('validate', '.todolist-form form', function(e, val, args) {
        var result = { valid: true };

        if (!val) {
          result.valid = false;
          result.errorMsg = '';
        } else if (val.length > 255) {
          result.valid = false;
          result.errorMsg = '';
          simple.dialog.message({
            content: '任务清单名称最长 191 个字符'
          });
        }

        return result
      });

    // fold todolist
    wrapper.on('click', '.todolist a.fold', foldTodolist);

    // del and edit todolist
    wrapper.on('ajax:success', '.todolist-actions .del', delTodolistSuccess)
      .on('ajax:beforeSend', '.todolist-actions .del', beforeDelTodolist)
      .on('ajax:success', '.todolist-actions .edit', showEditTodolist)
      .on('click', '.btn-cancel-update-todolist', hideEditTodolist)
      .on('ajax:success', '.todolist-form.edit .form', updateTodolist)
      .on('ajax:success', '.todolist-actions .close', closeTodolist)
      .on('ajax:success', '.todolist-actions .reopen', reopenTodolist);

    // archive todolist
    wrapper.on('ajax:success', '.todolist-actions .archive', archiveTodolistSuccess);
  });

  function showTodolistForm( e ) {
    e.preventDefault();
    var form = $('.todolist-form.new').show(),
      nameEl = form.find('.todolist-name'),
      descEl = form.find('.todolist-desc');

    nameEl.focus();
    var autosave = simple.autosave({
      el: $('[data-autosave]', form)
    });
    form.find('.form').data('autosave', autosave);
    tower.selectText(nameEl);
    descEl.autosize();
    $('.init.init-todos').hide();
    $('.init-todo-empty, .init-todo-completed').hide();

    if ($('.page-inner').hasClass('project-kanban')) {
      $(e.currentTarget).hide();
    }
  }

  function hideTodolistForm() {
    var $form = $('.todolist-form.new');

    $form.find('.todolist-name, .todolist-desc').val('')
      .removeClass('error')
    $form.find('.cb-visitor-lock').prop('checked', false);
    $form.hide();
    $('.init.init-todos').show();
    $('.init-todo-empty, .init-todo-completed, .btn-new-todolist').show();
  }

  function createTodolistSuccess(e, result) {
    if (!result.success && result.msg) {
      simple.dialog.message({
        content: result.msg
      });
      return;
    }

    var $list = $(result.html);
    hideTodolistForm();
    var $default = $('.default-todolist');
    if ($default.length) {
      $default.after($list);
    } else {
      $list.prependTo($('.todolists'));
    }
    $list.find('.btn-new-todo').trigger('click');

    tower.initPermission($list);

    $('.workspace .page:last .page-inner').trigger('todolistcreate', [$list]);
    $('.init-todo-empty, .init-todo-completed').remove();
    $('.init.init-todos').remove();

    tower.bubbleGuideClose({step: 5});
  }

  function createTodolistShortcuts(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      $(e.currentTarget)
        .find('button[type=submit]')
        .trigger('click');
    }
  }

  function beforeDelTodolist(e, xhr, settings) {
    if ( $(e.target).closest('.page-inner').is("#page-todolist") ) {
      simple.loading({
        type: 'global',
        msg: '正在删除任务清单...'
      });
    }
  }

  function delTodolistSuccess(e, result) {
    var todolist = $(e.target).closest('.todolist');

    if (todolist.closest('.page-inner').is("#page-todolist")) {
      simple.loading.destroy();
      tower.stack.currentPage.el.prev('.page').find('.link-page-behind').trigger('click');
    } else {
      todolist.fadeOut(function() {
        $(this).remove();
      });
    }
  }

  function showEditTodolist(e, result) {
    var form = $(result.html),
      nameEl = form.find('.todolist-name'),
      descEl = form.find('.todolist-desc');

    $(e.target).closest('.title').hide().after(form);
    nameEl.focus()
    descEl.autosize();
    tower.selectText(nameEl);
    tower.initPermission(form);
  }

  function hideEditTodolist(e) {
    $(e.currentTarget).parents('.todolist-form.edit')
    .prev('.title').show()
    .end().remove();
  }

  function updateTodolist(e, result, status, xhr) {
    var form = $(e.target);
    var result = $(result.html);

    var title = form.closest('.todolist').find('.title');
    title.find('h4, .desc').remove();
    title.append(result).show();
    tower.highlight(title);

    form.closest('.todolist-form.edit').remove();

    if ($('#page-todolist').length > 0) {
      tower.stack.load(location.href, {
        noCache: true,
        replace: true
      });
    }
  }

  function closeTodolist(e, result) {
    if (result.success) {
      var link = $(this),
        todolist = link.parents('.todolist:first'),
        page = todolist.closest('.page-inner');

      if (page.is('#page-todolist')) {
        todolist.addClass('todolist-completed');
      } else {
        todolist.fadeOut(function() {
          if (page.is('#page-todolists')) {
            var wrap = $('.todolists-completed');
            if (wrap.find('a').length) {
              wrap.append(',')
            }

            wrap.append(todolist.find('.title h4 a:not(.fold)'));
          }

          $(this).remove();
        });
      }
    }
  }

  function reopenTodolist(e, result) {
    if (result.success) {
      var link = $(this),
        todolist = link.parents('.todolist:first');
        todolist.removeClass('todolist-completed');
    }
  }

  function foldTodolist(e) {
    var $target = $(e.currentTarget);
    var $todolist = $target.closest('.todolist');
    var folded = !$todolist.hasClass('folded');

    $todolist.toggleClass('folded', folded)
    simple.util.storage.set('foldTodolist '+ $todolist.data('guid'), folded);
  }

  function archiveTodolistSuccess(e, result) {
    if (result.success) {
      $(e.currentTarget).closest('.todolist').fadeOut('fast', function() {
        $(this).remove();
      });
    }
  }

  $.extend(tower, {
    sortTodolists: function(selector) {
      var $page = $('.workspace .page-inner');

      selector = selector || $page.find('.todolists');

      if (!selector.is('.todolists') || $page.is('[data-archived], [data-not-access], [data-deleted]')) {
          return;
      }

      selector.sortable({
        axis: 'y',
        handle: '.title h4 a',
        scrollSensitivity: 20,
        distance: 5,
        items: '.todolist',
        cursor: 'move',
        helper: 'clone',
        tolerance: 'pointer',
        placeholder: 'todolist-placeholder',
        beforestart: function(e, ui) {
          var listWrap = ui.item.parent( ".todolists" ),
            lists = listWrap.children( ".todolist" ),
            prevLists = ui.item.prevAll( ".todolist" ),
            nextLists = ui.item.nextAll( ".todolist" ),
            listsH = listWrap.outerHeight(),
            placeholderH = 54,
            listTop = ui.item.offset().top - listWrap.offset().top,
            paddingTop = listTop - prevLists.length * placeholderH,
            paddingBottom = listsH - lists.length * placeholderH - paddingTop;

          lists.addClass( "collapse" );

          listWrap.css({
            paddingTop: paddingTop,
            paddingBottom: paddingBottom
          });
        },
        stop: function(e, ui) {
          var list = ui.item;
          var lists = list.parent().css({
            'paddingTop': 0,
            'paddingBottom': 0
          })
          .find( ".todolist" )
          .removeClass('collapse');

          var offsetTop = list.offset().top;
          var scrollTop = $(document).scrollTop();
          simple.scrollTo({
            offset: offsetTop - (e.pageY - scrollTop) + 40
          });
          setTimeout( function() {
            tower.highlight( list );
          }, 500 );
        },
        update: function(e, ui) {
          var list = ui.item;
          var listsGuids = list.parent().find('.todolist:visible').map(function() {
            return $(this).data('guid');
          }).get();
          var todolistId = list.data( "guid" );
          var projectId = list.data( "project-guid" );

          listsGuids = listsGuids.reverse();

          var data = {
            guids: listsGuids.join(',')
          };

          $.ajax({
            url: "/projects/" + projectId + "/lists/" + todolistId + "/reorder",
            data: data
          });
        }
      });

      $('.workspace .page:last .page-inner').on('todolistcreate', function(e, list) {
        $('.todolists').sortable('refresh');
      });
    },

    adjustTodolist: function() {
      var guid, $todolist, folded;
      $('.todolist').each(function() {
        $todolist = $(this);
        guid = $todolist.data('guid');
        folded = (simple.util.storage.get('foldTodolist ' + guid) == 'true');
        $todolist.toggleClass('folded', folded)
      });
    },
  });

})(jQuery);
